import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { StepArgs } from './types';

type StepProps<T> = StepArgs<T> & {
  isSelected: boolean;
  classNames?: {
    wrapper?: string;
  };
};

export const Step = <T,>({ title, isSelected, classNames, ...rest }: StepProps<T>) => {
  const { t } = useTranslation('ALL');

  return (
    <li
      data-selected={isSelected}
      className={twMerge(
        'grid group/step gap-y-3 grid-rows-[1fr,fit-context] grid-cols-[1fr,2.5rem,1fr] place-items-center grow min-w-48 text-secondary-700 data-[selected=true]:text-brand-600',
        '[&:has(~li[data-selected=true])]:text-tertiary-600 motion-safe:transition-colors motion-safe:duration-300 motion-reduce:transition-none',
        classNames?.wrapper
      )}
    >
      <span className='h-px w-full bg-secondary-border group-first-of-type/step:hidden' />
      <div className='grid justify-self-end rounded-lg border border-primary-border p-[0.5625rem] shadow-md group-first-of-type/step:col-span-2'>
        <rest.icon className='size-5' />
      </div>
      <span className='h-px w-full bg-secondary-border group-last-of-type/step:hidden' />
      <div className='col-span-3'>
        <p className=' min-w-fit text-nowrap text-sm font-semibold first-letter:capitalize'>{t(title as any)}</p>
      </div>
    </li>
  );
};
